/* session/reducer */
import { createReducer } from "typesafe-actions";
import { SessionActionTypes, SessionState } from "./types";
import {
  fetchRequest,
  fetchSuccess,
  fetchError,
  dirty,
  unDirty,
  fetchSecondRequest,
  fetchSecondSuccess,
} from "./actions";

export const initialState: SessionState = {
  data: null,
  errors: undefined,
  loading: false,
  dirty: false,
  second: undefined,
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSecondRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchSecondSuccess>
  | ReturnType<typeof fetchError>
  | ReturnType<typeof dirty>
  | ReturnType<typeof unDirty>;


export default createReducer<SessionState, ActionType>(initialState)
  .handleType(SessionActionTypes.FETCH, (state) => {
    return { ...state, loading: true, dirty: true, errors: undefined };
  })
  .handleType(SessionActionTypes.SECOND_FETCH, (state) => {
    return {
      ...state,
      loading: true,
      dirty: true,
      isSecondUser: true,
      errors: undefined,
    };
  })
  .handleType(SessionActionTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(SessionActionTypes.SECOND_FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      second: {
        loading: false,
        data: action.payload,
        errors: undefined,
      },
    };
  })
  .handleType(SessionActionTypes.FETCH_ERROR, (state, action) => {
    return { ...state, loading: false, errors: action.payload, dirty: false };
  })
  .handleType(SessionActionTypes.DIRTY, (state) => {
    return {
      ...state,
      loading: false,
      dirty: true,
      data: null,
      isSecondUser: false,
      second: undefined,
      errors: undefined,
    };
  })
  .handleType(SessionActionTypes.UN_DIRTY, (state) => {
    return {
      ...state,
      dirty: false,
    };
  });
